import type { SVGProps } from 'react';

const Show = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={20} width={21} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      clipRule='evenodd'
      d='M4.125 10a.68.68 0 0 1 .138-.42c.55-.663 1.437-1.628 2.538-2.422 1.108-.8 2.377-1.388 3.699-1.388s2.591.588 3.7 1.388c1.1.794 1.988 1.759 2.537 2.423a.68.68 0 0 1 .138.419.68.68 0 0 1-.138.42c-.55.663-1.437 1.628-2.538 2.422-1.108.8-2.377 1.388-3.699 1.388s-2.591-.588-3.7-1.388c-1.1-.794-1.988-1.759-2.537-2.423A.68.68 0 0 1 4.125 10ZM10.5 4.52c-1.689 0-3.214.746-4.43 1.624-1.223.883-2.19 1.937-2.774 2.645l-.006.007c-.272.34-.415.77-.415 1.204 0 .435.143.864.415 1.204l.006.007c.584.708 1.55 1.762 2.773 2.644 1.217.879 2.742 1.625 4.431 1.625 1.688 0 3.214-.746 4.43-1.625 1.223-.882 2.19-1.936 2.774-2.644l.006-.007c.272-.34.415-.77.415-1.204 0-.435-.143-.864-.415-1.204l-.006-.007c-.584-.708-1.55-1.762-2.773-2.645-1.217-.878-2.742-1.624-4.431-1.624Zm0 2.697a2.783 2.783 0 1 0 0 5.566 2.783 2.783 0 0 0 0-5.566ZM8.967 10a1.533 1.533 0 1 1 3.066 0 1.533 1.533 0 0 1-3.066 0Z'
      fill='#505050'
      fillRule='evenodd'
    />
  </svg>
);
export default Show;
